import { Route, Routes } from 'react-router-dom';
import PortfolioListPage from './list';
import PortfolioDetailPage from './detail';
import CreatePortfolioPage from './create';

export default function PortfolioRouting() {
  return (
    <Routes>
      <Route index element={<PortfolioListPage />} />
      <Route path="/create" element={<CreatePortfolioPage />} />
      <Route path="/:id" element={<PortfolioDetailPage />} />
    </Routes>
  );
}
